module.exports = __webpack_public_path__ + "media/images/illus plante-78a6f5c2560e94e8516cb72a41b898ff.svg";